const INJECTED_BRIDGE_PATTERN = /window\.webkit\.messageHandlers/


// Some mobile in-app browsers (Meta's Facebook/Instagram apps, etc.) inject a
// native-bridge script into every page they load. It runs inline, so its frames
// carry the document path rather than an off-origin URL and slip past the origin
// check. We recognize the bridge global it touches and drop the error outright.
//
export default function isInjectedBridgeError(values) {
  return values.some(({ value }) => INJECTED_BRIDGE_PATTERN.test(value || ''))
}
